import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "alert__icon"
};
const _hoisted_2 = {
  key: 0,
  width: "9",
  height: "31",
  viewBox: "0 0 9 31",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M8.16748 3.90527C8.16748 4.47917 8.0625 5.24202 7.85254 6.19385C7.65658 7.13167 7.40462 8.23747 7.09668 9.51123C6.80273 10.715 6.4668 12.2197 6.08887 14.0254C5.71094 15.8171 5.31201 18.0356 4.89209 20.6812H3.27539C2.85547 18.0077 2.45654 15.7821 2.07861 14.0044C1.70068 12.2267 1.36475 10.736 1.0708 9.53223C0.80485 8.42643 0.559896 7.34863 0.335938 6.29883C0.111979 5.23503 0 4.43717 0 3.90527C0 2.82747 0.398926 1.91064 1.19678 1.15479C1.99463 0.384928 2.95345 0 4.07324 0C5.17904 0 6.13786 0.384928 6.94971 1.15479C7.76156 1.91064 8.16748 2.82747 8.16748 3.90527ZM8.12549 27.106C8.12549 28.1698 7.71956 29.0866 6.90771 29.8564C6.10986 30.6123 5.17204 30.9902 4.09424 30.9902C3.00244 30.9902 2.05062 30.6123 1.23877 29.8564C0.440918 29.0866 0.0419922 28.1698 0.0419922 27.106C0.0419922 26.0422 0.440918 25.1253 1.23877 24.3555C2.05062 23.5716 3.00244 23.1797 4.09424 23.1797C5.17204 23.1797 6.10986 23.5716 6.90771 24.3555C7.71956 25.1253 8.12549 26.0422 8.12549 27.106Z",
  fill: "currentColor"
}, null, -1);
const _hoisted_4 = [_hoisted_3];
const _hoisted_5 = {
  key: 1,
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_6 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12.5896 25.4301L29.6984 8.71577L28.3008 7.28516L11.9145 23.2936L3.72192 14.7374L2.27734 16.1206L11.1685 25.4063L11.867 26.1359L12.5896 25.4301Z",
  fill: "white"
}, null, -1);
const _hoisted_7 = [_hoisted_6];
const _hoisted_8 = {
  class: "alert__message"
};
export default {
  __name: 'DcAlert',
  props: {
    type: {
      type: String,
      default: 'info'
    }
  },
  setup(__props) {
    const alertClasses = {
      info: 'alert--info',
      warning: 'alert--warning',
      error: 'alert--error',
      success: 'alert--success'
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["alert", `${alertClasses[__props.type]}`])
      }, [_createElementVNode("span", _hoisted_1, [_renderSlot(_ctx.$slots, "icon", {}, () => [__props.type != 'success' ? (_openBlock(), _createElementBlock("svg", _hoisted_2, _hoisted_4)) : _createCommentVNode("", true), __props.type == 'success' ? (_openBlock(), _createElementBlock("svg", _hoisted_5, _hoisted_7)) : _createCommentVNode("", true)])]), _createElementVNode("span", _hoisted_8, [_renderSlot(_ctx.$slots, "message")])], 2);
    };
  }
};